'use client';
import Image from 'next/image';
import { useCallback, useState } from 'react';
import { CollapsibleTile } from '../../../components';
import { useTranslations } from 'next-intl';
import { useBreakpoint, useInitialize, useTheme } from '../../../hooks';
import { MatchingSection } from './styles';
import { LandingPageHeadline } from './components/LandingPageHeadline';
import { MatchingStep } from '../../../types/Match';
import { fetchMatchingSteps } from '../../../api/matching/fetchMatchingSteps';

const LandingPageMatchingSection = () => {
    const t = useTranslations('landing_page');
    const [openedStep, setOpenStep] = useState<number | null>(0);
    const { colors } = useTheme();
    const breakpoint = useBreakpoint();

    // model an data fetching
    const [steps, setSteps] = useState<MatchingStep[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const fetchData = useCallback(async () => {
        setIsLoading(true);
        const { steps, error } = await fetchMatchingSteps();
        if (!error) {
            setSteps(steps);
            setOpenStep(steps[0].order);
        }
        !error && setSteps(steps);
        setIsLoading(false);
    }, []);
    useInitialize(() => fetchData());

    const renderStep = (step?: MatchingStep) => {
        const index = step?.order;
        const isExpanded = openedStep === step?.order || step === undefined;
        const toggle = () => (isExpanded ? setOpenStep(null) : setOpenStep(index ?? null));
        const loading = step === undefined;

        return (
            <CollapsibleTile
                isLoading={loading}
                key={`tile_${index}`}
                title={step?.title ?? ''}
                description={step?.description ?? ''}
                isExpanded={isExpanded}
                toggleElement={toggle}
                iconProps={{ sx: { color: colors.white } }}
                titleColor={colors.secondaryDark}
                image={
                    <Image
                        src={step?.imageSrc ?? ''}
                        width={400}
                        height={300}
                        alt={`Image of Matching Step ${step?.order}`}
                        style={{ borderRadius: 4, backgroundColor: colors.secondaryDark }}
                    />
                }
                sx={{
                    color: isExpanded ? colors.onSecondaryContainer : colors.white,
                    borderBottom: `1px solid ${colors.outline}`
                }}
            />
        );
    };

    return (
        <MatchingSection breakpoint={breakpoint} my={10} py={7} px={3}>
            <LandingPageHeadline headline={t('how_to_matching_title')} color={colors.white} />
            {isLoading ? renderStep(undefined) : steps.map((step) => renderStep(step))}
        </MatchingSection>
    );
};

export { LandingPageMatchingSection };
